<template>
  <el-container>
    <el-header>
      <div style="margin-top: 15px;width: 100%;height: 100%;background-color:#529BEB;padding-top: 15px">
        <el-row :gutter="18">
          <el-col :span="3">
            <div class="grid-content bg-purple" style=" background-color:#529BEB;  text-align: center">
              <p style="color: white;font-size: 20px;">快速检索</p>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple" style="background-color:#529BEB">
              <el-select v-model="role" clearable placeholder="角色" size="mini">
                <el-option
                    v-for="(role,index) in roleList"
                    :key="index"
                    :label="role.roleName"
                    :value="role.roleName">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple" style="background-color:#529BEB;float: right ">
              <el-button icon="el-icon-search" size="small" circle @click="searchRole(role)"></el-button>
              <el-button icon="el-icon-refresh" size="small" circle @click="refresh"></el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-container>
      <el-main>
        <template>
          <el-table
              :data="showList"
              style="width: 100%;height: 100%"
              border
              stripe>
            <el-table-column
                prop="roleName"
                label="角色名"
                min-width="20%">
            </el-table-column>
            <el-table-column
                label="权限"
                min-width="60%">
              <template slot-scope="scope">
                <span v-for="(droit,index) in showList[scope.$index].droitList" :key="index" style="margin-right:10px;">
                  {{droit.action_iden}}
                </span>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                min-width="20%">
              <el-button v-popover:popover1 size="mini">修改</el-button>
              <el-popover
                  ref="popover1"
                  placement="top-start"
                  title="标题"
                  width="200"
                  trigger="click"
                  content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
              </el-popover>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
    import { mapActions, mapState} from 'vuex'
    import authority from "../../api/authority";
    export default {
        name: 'roleSelect',
        methods: {
            ...mapActions('Authority',['getRoleList']),
            //检索
            searchRole(role){
                this.showList=this.roleList
                if (role===''){
                    this.$message('请输入检索内容')
                }
                else{
                    this.showList=this.showList.filter(res=>{
                        return res.roleName===role
                    })
                    if (this.showList.length===0){
                        this.$message('不存在该角色，请重新查询')
                        this.showList=this.roleList
                    }
                }
            },
            //重置
            refresh(){
                this.role=''
                this.showList=[...this.roleList]
            },
        },
        data() {
            return {
                role:'',
                showList:[],
            };
        },
        computed:{
            ...mapState('Authority',['roleList'])
        },
        mounted(){
            //获取角色信息
            this.getRoleList().catch((err)=> {
                this.$message.error(`角色信息获取失败 (${err[0]})：${err[1]}`)
            })
        },
        watch:{
            roleList:function () {
                //根据角色查询权限
                for (let i=0;i<this.roleList.length;i++){
                    const roleId=this.roleList[i].roleId
                    const url=`/user/droitByRoleId/${roleId}`
                    this.$set(this.roleList[i],'droitList',[])
                    authority.getRoleDroit(url).then((res)=>{
                        res.map((item)=>{
                            this.roleList[i].droitList.push(item)
                        })
                    }).catch((err)=>{
                        this.$message.error(`角色权限查询失败 (${err[0]})：${err[1]}`)
                    })
                }
                this.showList=[...this.roleList]
            },
        },
    };
</script>

<style scoped>
  * {
    margin: 0px 0px 0px 0px;
  }

  .el-header {
    line-height: 10%;
    height: 5%;
    margin-bottom: 5px;
  }

  .el-footer {
    line-height: 5%;
    height: 5%;
  }

  .el-main {
    text-align: center;
    line-height: 160px;
    /*设置高度会导致下方无法显示滚动条*/
    /*height: 100%;*/
  }

  .el-container {
    height: 100%;
    width: 100%;
  }

  #main {
    height: 100%;
    width: 100%;
    background-color: #F9F9F9;
  }


  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// src/components/authority/roleSelect.vue